import { isNil } from 'ramda';
import { NavigationType, } from '@/search-for-retail/evaluate/models';
import { generateKeyForRefinement } from '@/search-for-retail/common/facet-navigation';
export const canUserViewRoute = (roles, activeUser) => {
    if (isNil(activeUser)) {
        return false;
    }
    return !roles.length || roles.some((role) => activeUser.allowedAccess.includes(role));
};
export const filterRoutesByUserAccess = (routes, activeUser) => routes.reduce((filteredRoutes, route) => {
    var _a;
    const subroutes = ((_a = route.subroutes) === null || _a === void 0 ? void 0 : _a.length) ? filterRoutesByUserAccess(route.subroutes, activeUser) : undefined;
    if (canUserViewRoute(route.roles, activeUser)) {
        filteredRoutes.push(Object.assign(Object.assign({}, route), { subroutes }));
    }
    return filteredRoutes;
}, []);
export const patchDrawerRoutesWithFields = (routes, routeFields) => (routeFields ? routes.reduce((patchedRoutes, route) => {
    var _a;
    const subroutes = ((_a = route.subroutes) === null || _a === void 0 ? void 0 : _a.length) ? patchDrawerRoutesWithFields(route.subroutes, routeFields) : undefined;
    patchedRoutes.push(Object.assign(Object.assign(Object.assign({}, route), routeFields), { subroutes }));
    return patchedRoutes;
}, []) : routes);
export const filterSelectedNavigationsFromResponse = (response) => {
    const availableNavigations = response.availableNavigation;
    const selectedNavigations = response.selectedNavigation;
    return selectedNavigations === null || selectedNavigations === void 0 ? void 0 : selectedNavigations.filter((selectedNav) => {
        var _a;
        // Find matching navigation by name and type
        const matchingAvailableNav = availableNavigations === null || availableNavigations === void 0 ? void 0 : availableNavigations.find((availableNav) => (availableNav === null || availableNav === void 0 ? void 0 : availableNav.name) === (selectedNav === null || selectedNav === void 0 ? void 0 : selectedNav.name)
            && (availableNav === null || availableNav === void 0 ? void 0 : availableNav.type) === (selectedNav === null || selectedNav === void 0 ? void 0 : selectedNav.type));
        if (!matchingAvailableNav) {
            return false;
        }
        // Check if the specific refinements exist in available navigations
        return (_a = selectedNav === null || selectedNav === void 0 ? void 0 : selectedNav.refinements) === null || _a === void 0 ? void 0 : _a.every((selectedRefinement) => {
            var _a;
            return (_a = matchingAvailableNav === null || matchingAvailableNav === void 0 ? void 0 : matchingAvailableNav.refinements) === null || _a === void 0 ? void 0 : _a.some((availableRefinement) => {
                if ((selectedRefinement === null || selectedRefinement === void 0 ? void 0 : selectedRefinement.type) === NavigationType.Value
                    && (availableRefinement === null || availableRefinement === void 0 ? void 0 : availableRefinement.type) === NavigationType.Value) {
                    return (availableRefinement === null || availableRefinement === void 0 ? void 0 : availableRefinement.value) === (selectedRefinement === null || selectedRefinement === void 0 ? void 0 : selectedRefinement.value);
                }
                if ((selectedRefinement === null || selectedRefinement === void 0 ? void 0 : selectedRefinement.type) === NavigationType.Range
                    && (availableRefinement === null || availableRefinement === void 0 ? void 0 : availableRefinement.type) === NavigationType.Range) {
                    return ((availableRefinement === null || availableRefinement === void 0 ? void 0 : availableRefinement.low) === (selectedRefinement === null || selectedRefinement === void 0 ? void 0 : selectedRefinement.low)
                        && (availableRefinement === null || availableRefinement === void 0 ? void 0 : availableRefinement.high) === (selectedRefinement === null || selectedRefinement === void 0 ? void 0 : selectedRefinement.high));
                }
                return false;
            });
        });
    });
};
export const createIdArrayFromSelectedNavigations = (navigations) => {
    const ids = [];
    navigations.forEach((navigation) => {
        var _a;
        (_a = navigation === null || navigation === void 0 ? void 0 : navigation.refinements) === null || _a === void 0 ? void 0 : _a.forEach((refinement) => {
            const id = generateKeyForRefinement(refinement, navigation === null || navigation === void 0 ? void 0 : navigation.name);
            ids.push({ name: navigation === null || navigation === void 0 ? void 0 : navigation.name, id });
        });
    });
    return ids;
};
export const compareAndFilterRefinements = (selectedNavigations, refinementItems) => {
    const matchingItems = [];
    // Filter refinementItems that match selectedNavigations
    refinementItems.forEach((item) => {
        const hasMatch = selectedNavigations.some((navigation) => {
            var _a;
            // Check if navigation names match
            if ((navigation === null || navigation === void 0 ? void 0 : navigation.name) !== (item === null || item === void 0 ? void 0 : item.navigationName)) {
                return false;
            }
            // Check if types match
            if ((navigation === null || navigation === void 0 ? void 0 : navigation.type) !== (item === null || item === void 0 ? void 0 : item.type)) {
                return false;
            }
            // Check refinements for matching values
            return (_a = navigation === null || navigation === void 0 ? void 0 : navigation.refinements) === null || _a === void 0 ? void 0 : _a.some((refinement) => {
                if ((refinement === null || refinement === void 0 ? void 0 : refinement.type) === NavigationType.Value && (item === null || item === void 0 ? void 0 : item.type) === NavigationType.Value) {
                    return (refinement === null || refinement === void 0 ? void 0 : refinement.value) === (item === null || item === void 0 ? void 0 : item.value);
                }
                if ((refinement === null || refinement === void 0 ? void 0 : refinement.type) === NavigationType.Range && (item === null || item === void 0 ? void 0 : item.type) === NavigationType.Range) {
                    return (refinement === null || refinement === void 0 ? void 0 : refinement.low) === (item === null || item === void 0 ? void 0 : item.low) && (refinement === null || refinement === void 0 ? void 0 : refinement.high) === (item === null || item === void 0 ? void 0 : item.high);
                }
                return false;
            });
        });
        if (hasMatch) {
            matchingItems.push(item);
        }
    });
    // Check if all refinementItems have matches (all are same)
    const allMatch = matchingItems.length === refinementItems.length;
    return {
        allMatch,
        matchingItems,
    };
};
export const filterRefinementsIds = (firstArray, secondArray) => secondArray.filter((secondItem) => firstArray.some((firstItem) => secondItem === firstItem.id));
